import React, { memo, useEffect, useState } from 'react'
import MaterialTable, { MTableBodyRow } from 'material-table'
import { TablePagination, Typography } from '@material-ui/core'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import isEqual from 'lodash/isEqual'

import TableToolbar from 'components/commons/TableToolbar'
import PortalModal, { usePortalModal } from 'components/commons/PortalModal'
import TableMoreOptions from './TableMoreOptions'
import DuplicateModal from '../DuplicateModal'

import { VALUES } from 'utils/constants'
import useQuestionnarieTableStyles from './styles'
import { patchToApi } from 'actions'
import { useStateValue } from 'context/store'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { useApiRequest } from 'utils/customHooks/useApiRequest'
import { userSettingsModule } from 'utils/utils'
import { publishQuestAction } from 'context/reducers/QuestionariesReducer'
import { QUESTIONNAIRE } from '../../constants'

// import TableActionPopover from '../commons/TableActionPopover'
// import { useGetUserSettings } from 'utils/customHooks/useGetUserSettings'
const url = `${process.env.REACT_APP_QUESTIONNAIRE_API}/questionnaire`

function ResultsTabletQuestionnaire({
   setViewQuestionnarie,
   columns,
   tableData,
   isSearch,
   searchCallback = () => {},
   actionEdit,
   cleanCallback = () => {},
   order,
   parentChildData = undefined,
   customActions = undefined,
   header = true
}) {
   const classes = useQuestionnarieTableStyles()
   const [{ questionaries: { publishState } = {} }, dispatch] = useStateValue()
   const { params, onClose, setModal } = usePortalModal()

   const [showModalDuplicate, setShowModalDuplicate] = useState(false)
   const [rowData, setRowData] = useState()
   const { data = [], pageSize, totalRows, pageNumber } = tableData

   const patchApiCall = useApiRequest(patchToApi, 'location')
   const previewQuestionnaire = id => {
      if (
         !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'VER CUESTIONARIO'
         )
      ) {
         return
      }
      dispatch({
         type: 'SaveQuest',
         questionaries: { ...id, previewMode: true },
         questions: []
      })
      setViewQuestionnarie('view-preview-questionnaire')
   }

   const deleteQuestionnaire = async rowData => {
      const deleteUrl = `${url}/active/${rowData?.id}`
      const resp = await patchApiCall(deleteUrl)
      if (resp) {
         const message = `El cuestionario ${rowData?.name}  ha sido eliminado de forma permanente`
         await searchCallback()
         dispatch(openSnackBarAction(message, 'success'))
      }
   }

   const onMoreActions = async (type, rowData) => {
      if (type == 'delete') {
         if (
            !userSettingsModule.buscarValorEnUserSettings(
               'operations',
               'ELIMINAR CUESTIONARIO'
            )
         ) {
            return
         }
         const message =
            'Señor usuario, está a punto de eliminar de forma permanente este cuestionario. ¿Desea continuar?'
         setModal({
            message,
            onConfirm: deleteQuestionnaire,
            iconColor: 'error',
            value: rowData
         })
      }
      if (type == 'duplicate') {
         setRowData(rowData)
         setShowModalDuplicate(true)
      }
   }

   const actions = customActions || [
      {
         icon: 'edit',
         tooltip: 'Editar fila',
         disabled: !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'EDITAR CUESTIONARIO'
         ),
         onClick: (_, rowData) => actionEdit(rowData)
      },
      {
         icon: 'visibilityIcon',
         tooltip: 'Ver cuestionario',
         disabled: !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'VER CUESTIONARIO'
         ),
         onClick: (_, rowData) => previewQuestionnaire(rowData)
      },
      {
         icon: ArrowForwardIcon,
         tooltip: 'Publicar',
         disabled: !userSettingsModule.buscarValorEnUserSettings(
            'operations',
            'PUBLICAR CUESTIONARIO'
         ),
         onClick: (_, rowData) => dispatch(publishQuestAction(rowData))
      },
      rowData => ({
         icon: () => (
            <TableMoreOptions rowData={rowData} onAction={onMoreActions} />
         )
      })
   ]

   useEffect(
      () =>
         isEqual(publishState, QUESTIONNAIRE.PUBLISHED_STATUS) &&
         searchCallback(),
      [publishState]
   )

   if (!data.length) {
      return (
         <Typography className={classes.noResultsText}>
            No hay registros que mostrar
         </Typography>
      )
   }

   return (
      <div className={classes.root}>
         <MaterialTable
            columns={columns}
            data={data}
            parentChildData={parentChildData}
            options={{
               actionsColumnIndex: -1,
               toolbar: isSearch,
               paging: isSearch,
               emptyRowsWhenPaging: false,
               header,
               headerStyle: {
                  textTransform: 'uppercase',
                  fontWeight: 400,
                  textAlign: 'center',
                  fontSize: '12px',
                  lineHeight: '16px',
                  borderTop: !isSearch ? '4px solid #3264DC' : ''
               },
               rowStyle: {
                  textAlign: 'center',
                  backgroundColor: '#FFF'
               }
            }}
            actions={actions}
            onOrderChange={() => {
               searchCallback(null, {
                  order: order === 'asc' ? 'desc' : 'asc'
               })
            }}
            localization={{
               header: {
                  actions: 'ACCIÓN'
               },
               toolbar: {
                  searchTooltip: 'Buscar',
                  searchPlaceholder: 'Buscar'
               },
               pagination: VALUES.PAGINATION_CONFIG,
               body: {
                  emptyDataSourceMessage: 'No hay registros que mostrar'
               }
            }}
            components={{
               Pagination: props => (
                  <TablePagination
                     {...props}
                     rowsPerPage={pageSize}
                     count={totalRows}
                     page={pageNumber}
                     onChangePage={(_, page) => searchCallback(null, { page })}
                     onChangeRowsPerPage={e => {
                        props.onChangeRowsPerPage(e)
                        searchCallback(null, { size: e.target.value })
                     }}
                  />
               ),
               Toolbar: props => (
                  <TableToolbar
                     {...props}
                     cleanCallback={cleanCallback}
                     totalRows={totalRows}
                  />
               )
            }}
         />
         <PortalModal params={params} onClose={onClose} />
         <DuplicateModal
            showComfirmationModal={showModalDuplicate}
            setShowComfirmationModal={setShowModalDuplicate}
            data={rowData}
         />
      </div>
   )
}

export default memo(ResultsTabletQuestionnaire)
